window.addEventListener("DOMContentLoaded", () => {
  const emailSubsTriggers = document.querySelectorAll(
    ".custom-email-subs-trigger"
  );
  const customEmailSubSection = document.getElementById(
    "custom-email-subscription"
  );
  const customEmailSubSectionMobile = document.getElementById(
    "custom-email-subscription-mobile"
  );
  const customEmailSubSectionMobileClose = document.getElementById(
    "custom-email-subscription-mobile-close"
  );

  emailSubsTriggers?.forEach((e) => {
    e.addEventListener("click", () => {
      if (customEmailSubSection) {
        if (customEmailSubSection.classList.contains("active")) {
          customEmailSubSection.classList.remove("active");
        } else {
          customEmailSubSection.classList.add("active");
        }
      }
      if (customEmailSubSectionMobile) {
        if (customEmailSubSectionMobile.classList.contains("active")) {
          customEmailSubSectionMobile.classList.remove("active");
        } else {
          customEmailSubSectionMobile.classList.add("active");
        }
      }
    });
  });

  customEmailSubSectionMobileClose?.addEventListener("click", () => {
    if (customEmailSubSectionMobile.classList.contains("active")) {
      customEmailSubSectionMobile.classList.remove("active");
    }
  });
});
